import { createFileRoute } from '@tanstack/react-router'
import { CompanySettingsPage } from '@/pages/company-settings'

export const Route = createFileRoute('/_authenticated/company')({
  staticData: { title: 'Company' },
  component: CompanySettingsPage,
})
